import { makeStyles } from '@material-ui/core'
import { ERROR_COLORS, GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UIkit'

export const useCreateStyles = makeStyles(theme => ({
  uploader: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '16px',
    cursor: 'pointer'
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    padding: '12px 15px 12px 15px',
    marginBottom: '12px'
  },
  list: {
    padding: 0
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    marginTop: '12px',
    width: '100%'
  },
  uplTitle: {
    fontSize: '14px',
    textAlign: 'center',
    '& span': {
      color: PRIMARY_COLORS[700]
    }
  },
  uplSubtitle: {
    fontSize: '12px',
    textAlign: 'center'
  },
  errorText: {
    fontSize: 11,
    color: ERROR_COLORS[400],
    position: 'absolute',
    bottom: -10,
    left: 10
  },
  relative: {
    position: 'relative'
  },
  customizedCheckbox: {
    margin: 0,
    padding: '4px 10px 4px 5px',
    border: `1px solid ${GRAY_COLORS[300]}`,
    borderRadius: 6,
    fontSize: 14,
    '& .MuiCheckbox-root': {
      padding: 0,
      marginRight: 6
    }
  },
  squareRadio: {
    padding: 0,
    width: 18,
    height: 18,
    marginRight: 3
  }
}))
